import { render, staticRenderFns } from "./IconLeftTop2.vue?vue&type=template&id=451db7ba&"
import script from "./IconLeftTop2.vue?vue&type=script&lang=js&"
export * from "./IconLeftTop2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('451db7ba')) {
      api.createRecord('451db7ba', component.options)
    } else {
      api.reload('451db7ba', component.options)
    }
    module.hot.accept("./IconLeftTop2.vue?vue&type=template&id=451db7ba&", function () {
      api.rerender('451db7ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/PopupButtonPositions/IconLeftTop2.vue"
export default component.exports